import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "react-bootstrap";

import CustomerSelect from "../../common/CustomerSelect";
import DepartmentSelect from "../../common/DepartmentSelect";
import CallTypeSelect from "../../common/CallTypeSelect";
import ProjectSelect from "../../common/ProjectSelect";
import UserSelect from "../../common/UserSelect";
import ProjectCategorySelect from "../../common/ProjectCategorySelect";
import ProjectOwnerSelect from "../../common/ProjectOwnerSelect";
import ProjectStatusSelect from "../../common/ProjectStatusSelect";

import ReportFilters from "../ReportFiltersComponent";

const Filters = ({
  onChange,
  filters,
  projects,
  setProjects,
  fetchData,
  handleResetFilters,
  loading,
  onExportClick,
  onPDFExportClick,
  exportDisabled
}) => (
  <ReportFilters
    onFetchClick={fetchData}
    onResetClick={handleResetFilters}
    title="Project Summary"
    loading={loading}
    csvExportAvailable
    pdfExportAvailable
    onCSVExport={onExportClick}
    onPDFExport={onPDFExportClick}
    exportDisabled={loading || exportDisabled}
  >
    <Row>
      <Col md={3}>
        <CustomerSelect
          placeholder="Select"
          label="Customer"
          isMulti
          onChange={onChange("customers")}
          value={filters.customers || []}
        />
      </Col>
      <Col md={3}>
        <ProjectSelect
          placeholder="Select"
          label="Project"
          isMulti
          onChange={onChange("projects")}
          selectedCustomers={filters.customers ? filters.customers : null}
          value={filters.projects || []}
          loadProjects={setProjects}
        />
      </Col>
      <Col md={3}>
        <DepartmentSelect
          placeholder="Select"
          label="Department"
          isMulti
          onChange={onChange("departments")}
          value={filters.departments || []}
        />
      </Col>
      <Col md={3}>
        <CallTypeSelect
          placeholder="Select"
          label="Project Type"
          isMulti
          value={filters.call_type || []}
          onChange={onChange("call_type")}
        />
      </Col>
    </Row>
    <Row>
      <Col md={3}>
        <ProjectStatusSelect
          placeholder="Select"
          label="Project Status"
          isMulti
          onChange={onChange("project_status")}
          value={filters.project_status || []}
        />
      </Col>
      <Col md={3}>
        <UserSelect
          selectedDepartment={filters.department}
          placeholder="Select"
          label="Resource 1"
          name="resource1"
          projects={projects}
          isMulti
          value={filters.resource1 || []}
          onChange={onChange("resource1")}
        />
      </Col>
      <Col md={3}>
        <UserSelect
          selectedDepartment={filters.department}
          placeholder="Select"
          label="Resource 2"
          name="resource2"
          projects={projects}
          isMulti
          value={filters.resource2 || []}
          onChange={onChange("resource2")}
        />
      </Col>
      <Col md={3}>
        <ProjectOwnerSelect
          selectedDepartment={filters.department}
          placeholder="Select"
          label="Owner"
          name="project_manager"
          isMulti
          value={filters.project_manager || []}
          projects={projects}
          onChange={onChange("project_manager")}
        />
      </Col>
    </Row>
    <Row>
      <Col md={3}>
        <ProjectCategorySelect
          placeholder="Select"
          label="Category"
          isMulti
          value={filters.category || []}
          onChange={onChange("category")}
        />
      </Col>
    </Row>
  </ReportFilters>
);

Filters.propTypes = {
  onChange: PropTypes.func.isRequired,
  filters: PropTypes.object,
  setProjects: PropTypes.func,
  projects: PropTypes.array,
  fetchData: PropTypes.func,
  handleResetFilters: PropTypes.func,
  loading: PropTypes.bool,
  onExportClick: PropTypes.func,
  onPDFExportClick: PropTypes.func,
  exportDisabled: PropTypes.bool
};

export default Filters;
